import React from 'react'
import { connect } from 'react-redux';
import { TrashIcon } from '@primer/octicons-react';

import { deleteCourse } from '../../actions/courses';

class DeleteCourseButton extends React.Component {
  handleDelete(event) {
    event.preventDefault()

    const { dispatch, course } = this.props;

    dispatch(deleteCourse(course.uuid));

    event.stopPropagation()
  }

  render() {
    return (
      <button
        className="outline-none mx-3"
        onClick={this.handleDelete.bind(this)}>
        <TrashIcon />
      </button>
    );
  }
}

export default connect()(DeleteCourseButton);
